import { Injectable } from '@angular/core';
import { KEYUTIL, KJUR } from 'jsrsasign';
import * as uuid from 'uuid';
import { AuthStore } from '../stores/auth.store';


const sessionKeys = {
  SingedToken: 'DpopProof',
  PublicJwk: 'dpopProofPub',
  PrivateJwk: 'dpopProofPrv',
}

@Injectable({
  providedIn: 'root'
})
export class DpopTokenService {

  constructor(private authStore: AuthStore) { }


  private createKeyPair(isForced = false) {
    if (!sessionStorage.getItem(sessionKeys.PrivateJwk) || isForced) {
      const kp = KEYUTIL.generateKeypair('RSA', 2048);
      const jwkPrv = KEYUTIL.getJWK(kp.prvKeyObj);
      const jwkPub = KEYUTIL.getJWK(kp.pubKeyObj);

      sessionStorage.setItem(sessionKeys.PrivateJwk, JSON.stringify(jwkPrv))
      sessionStorage.setItem(sessionKeys.PublicJwk, JSON.stringify(jwkPub))
    }
  }

  private getHeaders() {
    const jwkPub = JSON.parse(sessionStorage.getItem(sessionKeys.PublicJwk) || '{}');
    const header = {
      'alg': 'RS256',
      'typ': 'dpop+jwt',
      'jwk': jwkPub
    };

    return header;
  }

  private getClaims(htu: string, htm: string, isAtHasRequired: boolean = true) {
    const currentTimestamp = Math.floor(Date.now() / 1000);

    if(htu.includes('?')) {
      htu = htu.substring(0, htu.indexOf('?'));
    }
    
    const claims: any = {
      'jti': uuid.v4(),
      'iat': currentTimestamp,
      'exp': currentTimestamp + 5 * 60,
      'htm': htm,
      'htu': htu.trimEnd(),
    }

    if (isAtHasRequired) {
      claims.ath = this.getAtHash();
    }

    return claims;
  }

  private getAtHash() {

    // get the at_hash from the id_token
    const jwt = this.authStore.getIdToken();
    const [jwtHeader, jwtPayload, jwtSignature] = jwt.split('.');
    const jwtPayloadJsonString = atob(jwtPayload);
    const jwtPayloadJSON = JSON.parse(jwtPayloadJsonString);
    const atHash = jwtPayloadJSON.at_hash;
    return atHash;
  }

  generateAuthDpop(htu: string, htm: string) {

    this.createKeyPair(true);

    const jwkPrv = JSON.parse(sessionStorage.getItem(sessionKeys.PrivateJwk) || '{}');

    // Set headers for JWT
    const header = this.getHeaders();

    const claims = this.getClaims(htu, htm, false);;

    const sHeader = JSON.stringify(header);
    const sPayload = JSON.stringify(claims);
    const signedToken = KJUR.jws.JWS.sign(header.alg, sHeader, sPayload, KEYUTIL.getKey(jwkPrv));

    sessionStorage.setItem(sessionKeys.SingedToken, signedToken)

    return signedToken;
  }



  generateDpop(htu: string, htm: string) {

    if (!sessionStorage.getItem(sessionKeys.PrivateJwk)) return;
    this.createKeyPair();

    const jwkPrv = JSON.parse(sessionStorage.getItem(sessionKeys.PrivateJwk) || '{}');

    // Set headers for JWT
    const header = this.getHeaders();

    const claims = this.getClaims(htu, htm, true);;

    const sHeader = JSON.stringify(header);
    const sPayload = JSON.stringify(claims);
    const signedToken = KJUR.jws.JWS.sign(header.alg, sHeader, sPayload, KEYUTIL.getKey(jwkPrv));

    return signedToken;
  }
}
